import * as React from 'react';

type PropsT = {
  handleFileChange: (result: string) => void;
  handleIdName?: string;
};

class CropUpload extends React.Component<PropsT> {
  fileInput: React.RefObject<any>;

  constructor(props: PropsT) {
    super(props);
    this.fileInput = React.createRef();
    this.handleFile = this.handleFile.bind(this);
  }

  handleFile(e: any) {
    const reader = new FileReader();
    const file = e.target.files[0];
    if (!file) {
      return;
    }

    reader.onload = (img: any) => {
      if (this.fileInput && this.fileInput.current) {
        this.fileInput.current.focus();
        this.fileInput.current.value = '';
        this.props.handleFileChange(img.target.result);
      }
    };
    reader.readAsDataURL(file);
  }

  render() {
    return (
      <input
        ref={this.fileInput}
        type="file"
        accept="image/*"
        id={this.props.handleIdName}
        onChange={this.handleFile}
      />
    );
  }
}

(CropUpload as any).defaultProps = {
  handleIdName: 'crop-upload',
};

export default CropUpload;
